import Model from './model.js';

export default class Position extends Model {
    urlRoot() { return '/Positions'; }

    url() {
        if (this.company && !this.get(this.idAttribute)) {
            return `${this.company.url()}/positions`;
        }
        return super.url();
    }

    defaults() {
        return {
            hiddenAt: null
        };
    }

    constraints() {
        return {
            name: {presence: true}
        };
    }

    initialize({company = null}) {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);

        this.company = company;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/position.js